(function () {
    'use strict';
    /**
     * Service booking
     * @namespace
     * @property {HtmlInputElements} specialID
     * @property {Boolean} updateCalculator
     * @property {Array} disabledDates
     * @property {Integer} dateLoopCounter
     * @property {DateTime} today
     * @property {DateTime} selectedDate
     * @property {Boolean} increntalcar
     * @property {Integer} timeslots
     * @property {Array} addToCart
     * @property {HtmlElements} selectors
     */
    jQuery.validator.prototype.elements = function () {
        var validator = this,
            rulesCache = {};
        return $(this.currentForm)
                .find('input, select, textarea')
                .not(':submit, :reset, :image, [disabled]') //[readonly] er fjernet her
                .not(this.settings.ignore)
                .filter(function () {
                    if (!this.name && validator.settings.debug && window.console) {
                        console.error('%o has no name assigned', this);
                    }
                    if (this.name in rulesCache || !validator.objectLength($(this).rules())) {
                        return false;
                    }
                    rulesCache[this.name] = true;
                    return true;
                });
    };
    master.serviceBooking = {
        globals: {
            specialID: {
                calculator: jQuery('.js-special-product[data-special="SERVICECALCULATOR"]').val(),
                other: jQuery('.js-special-product[data-special="OTHER"]').val(),
                express: jQuery('.js-special-product[data-special="EXPRESS"]').val(),
                highlight: jQuery('.js-special-product[data-special="HIGHLIGHT"]').val(),
                contact: jQuery('.js-special-product[data-special="CONTACT"]').val()
            },
            updateCalculator: false,
            disabledDates: [],
            dateLoopCounter: 0,
            today: null,
            selectedDate: sessionStorage.getItem('selectedTimes') !== null ? JSON.parse(sessionStorage.getItem('selectedTimes')).dateSelected : null,
            increntalcar: false,
            timeslots: {
                calculator: 0,
                total: 0
            },
            addToCart: []
        },
        selectors: {
            form: jQuery('.js-service-bookservice-form'),
            serviceCalculator: jQuery('.js-bookservice-panel-service-calculator')
        },
        /**
         * @namespace
         * @property {any} loaderTimeout
         */
        utils: {
            loaderTimeout: undefined,
            /** @function */
            /**
             * Show / hide loader
             */
            loader: function (show, element, text) {
                if (!show) {
                    clearTimeout(this.loaderTimeout);
                    jQuery('.js-modules-servicebooking-panel-loader').removeClass('loading').fadeOut(master.settings.animateSpeed).find('.js-loader-text').html('');
                }
                else {
                    this.loaderTimeout = setTimeout(function () {
                        jQuery('.js-modules-servicebooking-panel-loader').addClass('loading').fadeIn(master.settings.animateSpeed).find('.js-loader-text').html(text);
                    }, 300);
                }
            },
            /** @function */
            /**
             * Update tab index
             */
            updateTabIndex: function () {
                master.serviceBooking.selectors.form.find('input:not([type="hidden"]), textarea').each(function (i) {
                    jQuery(this).attr('tabindex', i + 1);
                });
            },

            // whenever the curtosy car checkbox is checked the Aflevering select gets disabled and vice versa
            handleCurtosyCar: function () {
                var courtesyCarChecked = $('.js-courtesy-car').is(':checked');
                var dropOffSelect = $('.js-booking-drop-off-time');
                var loanCar = dropOffSelect.find('[value="Aftenen før"]');
                var select = document.querySelector('option[value="Aftenen før"]');

                if (courtesyCarChecked) {
                    loanCar.attr('disabled', true);
                    select.setAttribute('style', 'display: none;');
                } else {
                    loanCar.attr('disabled', false);
                    select.setAttribute('style', 'display: inherit;');
                }
            }

        },
        /** @function */
        /**
         * Get moment vendor script
         */
        getScript: function (callback) {
            jQuery.getScript('//cdnjs.cloudflare.com/ajax/libs/moment.js/2.17.1/moment-with-locales.min.js', function () {
                master.serviceBooking.globals.today = moment().format(master.settings.booking.dateFormat);
                callback();
            });
        },
        /**
         * @namespace
         */
        api: {
            /** @function */
            /**
             * Construct and post object for booking calender. Set data and run callback
             * @param {string} action
             * @param {string} date
             * @param {function} callback
             * @async
             */
            countTimeslots: function () {
                var totalTimeslotsSelected = 0,
                    selectedServices = jQuery('.js-bookservice-servicelist').find('.js-bookservice-servicelist-item').filter(':checked');
                selectedServices.each(function () {
                    var serviceTimeslot = parseInt(jQuery(this).data('timeslot'));
                    totalTimeslotsSelected += serviceTimeslot;
                });
                master.serviceBooking.globals.timeslots.total = totalTimeslotsSelected;
                master.serviceBooking.tasks.enablers();
                return totalTimeslotsSelected;
            },
            getServiceIds: function () {
                var serviceIds = [],
                    selectedServices = jQuery('.js-bookservice-servicelist').find('.js-bookservice-servicelist-item').filter(':checked');
                selectedServices.each(function () {

                    var serviceTimeslot = jQuery(this)[0].value;
                    serviceIds.push(serviceTimeslot);
                });
                return serviceIds.join(',');
            },

            booking: function (action, date, callback) {
                var postObj = {
                        action: action,
                        date: date,
                        timeslot: master.serviceBooking.api.countTimeslots(),
                        serviceIds: master.serviceBooking.api.getServiceIds(),
                        workshop: jQuery('input[name="WorkshopID"]').val()
                    },
                    courtesyCarChecked = jQuery('.js-courtesy-car').is(':checked');
                if (courtesyCarChecked) {
                    postObj.increntalcar = true;
                    if (jQuery('#js-rentalcar-enabled').length) {
                        master.serviceBooking.globals.increntalcar = true;
                    }
                    else {
                        master.serviceBooking.globals.increntalcar = false;
                    }
                }
                else {
                    master.serviceBooking.globals.increntalcar = false;
                }
                if (date !== '') {
                    var bookingPost = jQuery.ajax({
                        url: master.data.serviceCalendar.endpoint,
                        type: 'POST',
                        beforeSend: function () {
                            jQuery('.js-bookservice-servicelist-item').prop('disabled', true);
                            if (jQuery('.js-bookservice-panel-toggler').is('.loading') === false) {
                                jQuery('.js-bookservice-panel-toggler').addClass('loading');
                            }
                        },
                        data: postObj
                    });
                    jQuery.when(bookingPost).then(function (data) {
                        if (data.Data !== null) {
                            if (courtesyCarChecked) {
                                jQuery('.js-service-rental-car-id').val(data.Data.RentalCarId);
                            }
                            else {
                                jQuery('.js-service-rental-car-id').val('');
                            }

                            // !beware of this setTimeout. Why is this necessary? and why not a classic promise?
                            setTimeout(function () {
                                jQuery('.js-bookservice-servicelist-item').prop('disabled', false);
                                jQuery('.js-bookservice-panel-toggler').removeClass('loading');

                                if (callback) {
                                    callback(data);
                                }

                                // disable handle curtosy car. leave it commented for the moment
                                // master.serviceBooking.utils.handleCurtosyCar();

                            }, 300);
                        }
                        else {
                            if (jQuery('.js-service-bookservice-form').data('workshop-selected') === 'True') {
                                jQuery('.js-bookservice-panel-toggler').removeClass('loading');
                                jQuery('.js-bookservice-datepicker-error-furtue').fadeIn('fast', function () {
                                    setTimeout(function () {
                                        master.serviceBooking.globals.selectedDate = master.serviceBooking.globals.today;
                                        master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
                                        jQuery('.js-bookservice-datepicker-error-furtue').fadeOut('fast');
                                    }, 2000);
                                });
                            }
                        }
                    }, function (data, error) {
                        master.utils.log(error, 'error');
                    });
                }
            },
            /** @function */
            /**
             * Construct and post object for service calculator. Run callback
             * @param {string} loadTxt
             * @param {function} callback
             * @async
             */
            calculator: function (callback, loadTxt) {
                var that = this,
                    postObj = {
                        action: master.data.serviceCalculator.actions.getserviceinfo,
                        licenseplate: jQuery('.js-module-licenseplate-lookup-input').val(),
                        workshop: jQuery('input[name="WorkshopID"]').val(),
                        transmission: jQuery('.js-service-calculator-extra-transmissions').filter(':checked').val() || null,
                        system: jQuery('.js-service-calculator-extra-systems').filter(':checked').val() || null,
                        package: jQuery('.js-service-calculator-packages').filter(':checked').val() || null
                    },
                    calculatorPost = jQuery.ajax({
                        url: master.data.serviceCalculator.endpoint,
                        type: 'POST',
                        dataType: 'JSON',
                        timeout: master.settings.booking.calculatorTimeout,
                        beforeSend: function () {
                            jQuery('.js-bookservice-calculator-errors').html('').hide();
                            master.serviceBooking.utils.loader(true, '.js-bookservice-panel-service-calculator', loadTxt);
                        },
                        data: postObj
                    });
                jQuery.when(calculatorPost).then(function (data) {
                    if (data.Data !== null) {
                        if (data.Data.StatusCode === 0) {
                            if (callback) {
                                master.serviceBooking.utils.loader(false);
                                callback(data);
                            }
                        }
                        else {
                            that.errors.handler(data, callback);
                        }
                    }
                }, function (data, error) {
                    if (error === 'timeout') {
                        master.serviceBooking.utils.loader(false);
                        that.errors.timeout();
                    }
                });
            },
            /**
             * @namespace
             */
            errors: {
                /** @function */
                /**
                 * Calendar error
                 */
                calendar: function () {
                    master.utils.log('calendar maxed out', 'error');
                    //master.serviceBooking.globals.disabledDates = [];
                },
                /** @function */
                /**
                 * Ajax timeout handler
                 */
                timeout: function () {
                    master.serviceBooking.selectors.serviceCalculator.find('.js-bookservice-panel-service-calculator-error').text(master.translations.base.data('error-message-data-issue'));
                },
                /** @function */
                /**
                 * Translate custom errors from feed to readable and set callback
                 * @param {object} data
                 * @param {function} callback
                 */
                handler: function (data, callback) {
                    var that = this,
                        jErrorText = data.Data.StatusText,
                        errorFound = false,
                        errorsMessages = [{
                            status: 'Authorization failed',
                            message: master.translations.base.data('error-message-workshop-not-available'),
                            action: that.actions.failed
                        }, {
                            status: 'Authentication failed',
                            message: master.translations.base.data('error-message-workshop-not-available'),
                            action: that.actions.failed
                        }, {
                            status: 'No data for vehicle',
                            message: master.translations.base.data('error-message-no-car'),
                            action: that.actions.vehicle
                        }, {
                            status: 'yielded no results',
                            message: master.translations.base.data('error-message-no-car'),
                            action: that.actions.vehicle
                        }, {
                            status: 'Registreringsnummer ikke fundet i bestanden',
                            message: master.translations.base.data('error-message-no-car'),
                            action: that.actions.vehicle
                        }, {
                            status: 'Object reference not set',
                            message: null,
                            action: that.actions.server
                        }, {
                            status: null,
                            message: null,
                            action: that.actions.server
                        }];
                    jQuery.each(errorsMessages, function (index, obj) {
                        if (jErrorText !== null) {
                            if (jErrorText.indexOf(obj.status) > -1) {
                                obj.action(data, callback, obj.message);
                                errorFound = true;
                            }
                        }
                    });
                    if (errorFound === false) {
                        that.actions.default(data, callback, master.translations.base.data('error-message-data-issue'));
                    }
                    jQuery('.js-booking-contact-workshop-modal').on('show', function () {
                        jQuery(this).find('.js-contact-modal-type-of-error').val(jErrorText);
                    }).modal();
                },
                /**
                 * @namespace
                 */
                actions: {
                    /** @function */
                    /**
                     * Default callback from error
                     */
                    default: function (data, callback, message) {
                        master.serviceBooking.utils.loader(false);
                        jQuery('.js-bookservice-calculator-errors').append(message).show();
                    },
                    /** @function */
                    /**
                     * Error from calculator feed
                     * @param {object} data
                     * @param {function} callback
                     */
                    failed: function (data, callback) {
                        master.serviceBooking.utils.loader(false);
                        master.serviceBooking.api.calculator(callback);
                    },
                    /** @function */
                    /**
                     * Licenseplate error
                     */
                    license: function () {
                        jQuery('.js-module-licenseplate-info').show().find('[data-item="Fabrikattekst"]').text('Ingen data');
                    },
                    /** @function */
                    /**
                     * Vehicle data error
                     * @param {object} data
                     * @param {function} callback
                     * @param {string} message
                     */
                    vehicle: function (data, callback, message) {
                        master.serviceBooking.utils.loader(false);
                        jQuery('.js-bookservice-calculator-errors').append(message).show();
                        jQuery('.js-bookservice-panel-service-calculator-carinfo-reg-date').val('');
                        master.store.local.unset('myLicenseplate');
                        master.store.local.unset('myCar');
                    },
                    /** @function */
                    /**
                     * Server error
                     * @param {function} callback
                     */
                    server: function (callback) {
                        master.serviceBooking.api.calculator(callback);
                    }
                }
            }
        },
        /**
         * @namespace
         */
        tasks: {
            /** @function */
            /**
             * Enable / disable sidebar based on services active
             */
            enablers: function () {
                if (jQuery('.js-bookservice-servicelist-item').not('.js-special-product[data-special="SERVICECALCULATOR"]').filter(':checked').length > 0) {
                    if (jQuery('.js-special-product[data-special="SERVICECALCULATOR"]').is(':checked') === false) {
                        jQuery('.js-bookservice-sidebar-panel').removeClass('disabled').prop('disabled', false);
                        jQuery('.js-reset-booking').fadeIn('fast');
                    }
                }
                else {
                    jQuery('.js-bookservice-sidebar-panel').addClass('disabled').prop('disabled', true);
                    jQuery('.js-reset-booking').fadeOut('fast');
                }
            },
            /** @function */
            /**
             * Delete orderline
             */
            serviceItemsInCart: function () {
                jQuery('.js-booking-remove-item-confirm').on('click', function () {
                    var jProductId = jQuery(this).find('.js-remove-item-product-id').val(),
                        postArr = [],
                        postObj = {};
                    postObj.deleteOrderline = master.serviceBooking.cart.promise(master.serviceBooking.cart.defers.deleteOrderline(jProductId));
                    postArr.push(postObj);
                    master.serviceBooking.cart.queue(postArr, 'reload');
                });
            },
            /** @function */
            /**
             * Handle clicks on service items, toggles panels, activates sidebar, show modal
             */
            serviceItems: function () {
                var that = this;
                jQuery('.js-bookservice-servicelist-item').on('click', function (event) {
                    master.serviceBooking.testForMismatchedWorkshopId(function(){
                        var isChecked = jQuery(event.target).is(':checked'),
                            productTimeslot = jQuery(event.target).data('timeslot'),
                            productID = jQuery(event.target).val();
                        if (jQuery(event.target).is('.js-bookservice-servicelist-item-in-cart') === true) {
                            event.preventDefault();
                            var jProduct = jQuery(event.target);
                            jQuery('.js-booking-remove-item-modal').on('show', function () {
                                jQuery(this).find('.js-remove-item-product-id').val(jProduct.val());
                                jQuery(this).find('.js-booking-remove-item-name').text(jProduct.data('name'));
                            }).on('hide', function () {
                                jQuery(this).find('.js-remove-item-product-id').val('');
                                jQuery(this).find('.js-booking-remove-item-name').text('');
                            }).modal();
                        }
                        else {
                            that.panelToggle(isChecked, productID, productTimeslot, false, jQuery(event.target).data('special'));
                            that.enablers();
                            if (!isChecked) {
                                master.serviceBooking.globals.disabledDates = [];
                                master.serviceBooking.globals.timeslots.total = (master.serviceBooking.globals.timeslots.total - (parseInt(productTimeslot)));
                            }
                            else {
                                master.serviceBooking.globals.timeslots.total = (master.serviceBooking.globals.timeslots.total + (parseInt(productTimeslot)));
                            }
                            if (productID !== master.serviceBooking.globals.specialID.calculator) {
                                master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
                            }
                            //jQuery( 'html' ).get( 0 ).style.setProperty( '--booking-selected-timeslots', master.serviceBooking.globals.timeslots.total );
                        }
                    });
                    
                    
                }).on('panel-toggle', function () {
                    var isChecked = jQuery(this).prop('checked');
                    that.panelToggle(isChecked, jQuery(this).val(), jQuery(this).data('timeslot'), true, jQuery(this).data('special'));
                    that.enablers();
                });
            },
            /** @function */
            /**
             * Toggles panels based on type of service item clicked
             */
            panelToggle: function (isChecked, productID, productTimeslot, triggered, special) {
                if (productID === master.serviceBooking.globals.specialID.calculator) {
                    if (isChecked) {
                        jQuery('.js-bookservice-panel-service-calculator').slideDown(master.settings.animateSpeed, function () {
                            if (jQuery('.js-module-licenseplate-lookup-input').val()) {
                                master.serviceBooking.updateCalculator = !triggered;
                                co3.util.scroll.toElement(jQuery('.js-bookservice-panel-service-calculator'), 0, true, true);
                                master.serviceBooking.api.calculator(master.serviceBooking.calculator.builder.init, 'Henter info');
                            }
                        });
                    }
                    else {
                        jQuery('.js-bookservice-panel-service-calculator').slideUp(master.settings.animateSpeed, function () {
                            master.serviceBooking.calculator.clear();
                        });
                    }
                }
                else if (productID === master.serviceBooking.globals.specialID.other) {
                    if (isChecked) {
                        jQuery('.js-bookservice-panel-other-comment').slideDown(master.settings.animateSpeed, function () {
                            co3.util.scroll.toElement(jQuery('.js-bookservice-panel-other-comment'), 0, true, true);
                        });
                    }
                    else {
                        jQuery('.js-bookservice-panel-other-comment').slideUp(master.settings.animateSpeed, function () {
                            master.serviceBooking.other.clear();
                        });
                    }
                }
                else if (special.toLowerCase() === 'contact') {
                    var checkContactChecked = jQuery('.js-bookservice-servicelist').find('.js-special-product[data-special="CONTACT"]').filter(':checked');
                    if (checkContactChecked.length > 0) {
                        jQuery('.js-bookservice-panel-other-contact').slideDown(master.settings.animateSpeed, function () {
                            co3.util.scroll.toElement(jQuery('.js-bookservice-panel-other-contact'), 0, true, true);
                        });
                    }
                    else {
                        jQuery('.js-bookservice-panel-other-contact').slideUp();
                    }
                }
            },
            /** @function */
            /**
             * Toggle input customer-wait if courtsy-car selected
             */
            courtesyCarToggle: function () {
                jQuery('.js-courtesy-car').on('change', function () {
                    master.serviceBooking.globals.disabledDates = [];
                    master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
                    if (jQuery(this).is(':checked') === true) {
                        jQuery('.js-customer-wait').prop({
                            checked: false
                        }).triggerHandler('change');
                    }
                });
            },
            /** @function */
            /**
             * Toggle inputs/selected if customer-wait selected
             */
            customerWaitToggle: function () {
                jQuery('.js-customer-wait').on('change', function () {
                    if (jQuery(this).is(':checked')) {
                        jQuery('.js-courtesy-car').prop({
                            checked: false
                        });
                        jQuery('.js-booking-pickup-time').append('<option value="' + jQuery('.js-booking-pickup-time').data('waitworkshop-text') + '">' + jQuery('.js-booking-pickup-time').data('waitworkshop-text') + '</option>').prop({
                            disabled: true,
                            required: false
                        }).val('Venter på værkstedet');
                        jQuery('.js-booking-drop-off-time').prop({
                            disabled: true,
                            required: false
                        }).find('option:not([disabled])').last().prop('selected', true);
                    }
                    else {
                        jQuery('.js-booking-pickup-time').prop({
                            disabled: false,
                            required: true
                        }).find('option[value="Venter på værkstedet"]').remove();
                        jQuery('.js-booking-drop-off-time').prop({
                            disabled: false,
                            required: true
                        });
                    }
                }).triggerHandler('change');

                jQuery('.js-bookservice-timepicker-panel').on('change', function() { 
                    jQuery('.js-customer-wait').triggerHandler('change'); 
                });
            },
            /** @function */
            /**
             * Set refered serviceID if conditions are fulfilled
             */
            toggledRefered: function () {
                var conditions = {
                        workshopSelected: jQuery( '.js-service-bookservice-form' ).data( 'workshop-selected' ) === 'True',
                        isReserved: jQuery( '.js-service-booking-orderlines' ).data( 'reserved' ) === 'True',
                        serviceID: co3.util.param.serviceid,
                        localServiceID: sessionStorage.referedServiceID
                    };
                

                if (conditions.serviceID) {
                    jQuery('.js-service-bookservice-form').find('.js-bookservice-servicelist-item[value="' + conditions.serviceID + '"]').trigger('click');
                }
                else if (conditions.localServiceID) {
                    jQuery('.js-service-bookservice-form').find('.js-bookservice-servicelist-item[value="' + conditions.localServiceID + '"]').trigger('click');
                    sessionStorage.removeItem('referedServiceID');
                }
                if (conditions.workshopSelected === false && conditions.serviceID !== undefined) {
                    sessionStorage.referedServiceID = conditions.serviceID;
                    setTimeout(function () {
                        jQuery('.js-master-service-bookservice').find('.js-module-workshop-lookup-input').focus();
                    }, 500);
                }
                if (conditions.isReserved === true) {
                    //master.serviceBooking.edit.clearReserved();
                }
            },
            /**
             * @namespace
             */
            details: {
                handlebars: {
                    detailsTmpl: null,
                    get: function () {
                        jQuery.getScript('//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.5/handlebars.min.js', function () {
                            master.serviceBooking.tasks.details.handlebars.compileTemplate();
                            master.serviceBooking.tasks.details.bindEvents();
                            master.serviceBooking.tasks.details.add();
                        });
                    },
                    compileTemplate: function () {
                        var detailsTmpl = jQuery('#js-master-booking-service-details-handlebars-template').html();
                        master.serviceBooking.tasks.details.handlebars.detailsTmpl = Handlebars.compile(detailsTmpl);
                    }
                },
                bindEvents: function () {
                    jQuery('.js-bookservice-servicelist-service-details').on('click', function () {
                        var jProductID = jQuery(this).closest('li').find('.js-bookservice-servicelist-item').val();
                        master.serviceBooking.tasks.details.get(jProductID);
                    });
                },
                /** @function */
                /**
                 * Get product details and add to modal
                 */
                get: function (jProductID) {
                    var url = '/servicedetails/data?productid=' + jProductID;
                    jQuery.ajax({
                        url: url,
                        type: 'POST',
                        beforeSend: function () {
                            jQuery('.js-page-preloader').fadeIn('fast');
                        }
                    }).done(function (data) {
                        setTimeout(function () {
                            jQuery('.js-page-preloader').fadeOut('fast');
                            jQuery('.js-booking-service-details-modal').html(master.serviceBooking.tasks.details.handlebars.detailsTmpl(data)).modal();
                            master.utils.breakIntoColumns();
                            master.utils.svg.init();
                        }, 500);
                    });
                },
                /** @function */
                /**
                 * Activate service in list
                 */
                add: function () {
                    jQuery('.js-booking-service-details-modal').on('click', '.js-booking-add-item-confirm', function () {
                        var serviceID = jQuery(this).find('.js-add-item-product-id').val();
                        jQuery('.js-booking-service-details-modal').modal('hide').html('');
                        jQuery('.js-service-bookservice-form').find('.js-bookservice-servicelist-item[value="' + serviceID + '"]').trigger('click');
                    });
                },
                init: function () {
                    master.serviceBooking.tasks.details.handlebars.get();
                }
            },
            init: function () {
                this.serviceItems();
                this.serviceItemsInCart();
                this.courtesyCarToggle();
                this.customerWaitToggle();
                this.toggledRefered();
                this.details.init();
            }
        },
        /**
         * @namespace
         */
        other: {
            /** @function */
            /**
             * Clear other-service textarea
             */
            clear: function () {
                jQuery('.js-bookservice-other-textarea').val('');
            }
        },
        /**
         * @namespace
         * @property {HtmlElement} transmissionsPanel
         * @property {HtmlElement} systemsPanel
         */
        calculator: {
            transmissionsPanel: jQuery('.js-bookservice-panel-service-calculator-extra-transmissions'),
            systemsPanel: jQuery('.js-bookservice-panel-service-calculator-extra-systems'),
            /** @function */
            /**
             * Reset service-calculator values
             */
            clear: function () {
                master.serviceBooking.calculator.transmissionsPanel.hide().find('input:checked').prop('checked', false);
                master.serviceBooking.calculator.systemsPanel.hide().find('input:checked').prop('checked', false);
                jQuery('.js-service-calculator-packages').prop('checked', false);
                jQuery('.js-service-id, .js-bookservice-panel-service-calculator-carinfo-reg-date, .js-bookservice-panel-service-calculator-carinfo-milage').val('');
                jQuery('.js-bookservice-panel-service-calculator-carinfo-reg-date-text').text('');
                master.serviceBooking.globals.timeslots.total = (master.serviceBooking.globals.timeslots.total - master.serviceBooking.globals.timeslots.calculator);
                master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
                master.serviceBooking.globals.timeslots.calculator = 0;
                jQuery('.js-bookservice-calculator-errors').html('').hide();
                jQuery('.js-servicepack-container').addClass('disabled').prop('disabled', true);
                if (!jQuery('.js-bookservice-servicelist-item:checked').length) {
                    jQuery('.js-bookservice-sidebar-panel').addClass('disabled').prop('disabled', true);
                }
                master.serviceBooking.edit.delete();
            },
            fetch: function () {
                /** @function */
                /**
                 * Get data
                 */
                jQuery('.js-module-licenseplate-lookup-input, .js-service-calculator-packages, .js-service-calculator-extra-transmissions, .js-service-calculator-extra-systems').on('change', function () {
                    if (jQuery('.js-module-licenseplate-lookup-input').val() && jQuery('.js-special-product[data-special="SERVICECALCULATOR"]').is(':checked')) {
                        master.serviceBooking.api.calculator(master.serviceBooking.calculator.builder.init, 'Henter info');
                    }
                    if (jQuery('.js-service-calculator-extra-transmissions').is(':checked') || jQuery('.js-service-calculator-extra-systems').is(':checked')) {
                        jQuery('.js-servicepack-container').removeClass('disabled').prop('disabled', false);
                    }
                    if (jQuery('.js-service-calculator-packages').is(':checked')) {
                        jQuery('.js-bookservice-sidebar-panel').removeClass('disabled').prop('disabled', false);
                    }
                });
            },
            /**
             * @namespace
             */
            builder: {
                /** @function */
                /**
                 * Set calculator main info and update
                 */
                mainInfo: function (data) {
                    var checkedPackage = jQuery('.js-service-calculator-packages').filter(':checked').val();
                    jQuery('.js-bookservice-panel-service-calculator-carinfo-id').val(data.Data.ServiceInfo.Services[0].Id);
                    jQuery('.js-bookservice-panel-service-calculator-carinfo-reg-date').val(data.Data.ServiceInfo.FirstRegDate);
                    jQuery('.js-bookservice-panel-service-calculator-carinfo-reg-date-text').text(data.Data.ServiceInfo.FirstRegDate);
                    jQuery('.js-bookservice-panel-service-calculator-carinfo-timeslots').val(data.Data.TimeslotRounded);
                    jQuery('.js-bookservice-panel-service-calculator-carinfo-price').val(data.Data[checkedPackage]);
                    jQuery('.js-bookservice-panel-service-calculator-carinfo-stelnr').val(data.Data.ServiceInfo.VIN);
                    if (master.serviceBooking.updateCalculator === true) {
                        master.serviceBooking.globals.timeslots.total = ((master.serviceBooking.globals.timeslots.total - master.serviceBooking.globals.timeslots.calculator) + parseInt(data.Data.TimeslotRounded));
                        master.serviceBooking.globals.timeslots.calculator = parseInt(data.Data.TimeslotRounded);
                        master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
                    }
                },
                /** @function */
                /**
                 * Set calculator extra info
                 */
                extras: function (data) {
                    master.serviceBooking.calculator.transmissionsPanel.hide();
                    master.serviceBooking.calculator.systemsPanel.hide();
                    if (data.Data.ServiceInfo !== null) {
                        var jSystems = data.Data.ServiceInfo.Systems,
                            jTransmissions = data.Data.ServiceInfo.Transmissions;
                        if (jTransmissions.length) {
                            for (var x = 0; x < jTransmissions.length; x++) {
                                master.serviceBooking.calculator.transmissionsPanel.find('input').eq(x).attr({
                                    value: jTransmissions[x].Id,
                                    id: 'transmissions' + x
                                }).next('label').attr('for', 'transmissions' + x).text(master.serviceBooking.calculator.transmissionsPanel.find('input').eq(x).data('text'));
                            }
                            master.serviceBooking.calculator.transmissionsPanel.show();
                        }
                        if (jSystems.length) {
                            for (var y = 0; y < jSystems.length; y++) {
                                master.serviceBooking.calculator.systemsPanel.find('input').eq(y).attr({
                                    value: jSystems[y].Id,
                                    id: 'systems' + y
                                }).next('label').attr('for', 'systems' + y).text(master.serviceBooking.calculator.systemsPanel.find('input').eq(y).data('text'));
                            }
                            master.serviceBooking.calculator.systemsPanel.show();
                        }
                    }
                },
                /** @function */
                /**
                 * Set price for packages
                 */
                packages: function (data) {
                    if (data.Data.ServiceInfo !== 'null') {
                        jQuery('.js-servicepack').each(function () {
                            if (jQuery(this).data('pack') === 'bronze') {
                                jQuery(this).find('.js-servicepack-price').text(co3.util.formatNumber(data.Data.Bronze));
                            }
                            if (jQuery(this).data('pack') === 'silver') {
                                jQuery(this).find('.js-servicepack-price').text(co3.util.formatNumber(data.Data.Silver));
                            }
                            if (jQuery(this).data('pack') === 'gold') {
                                jQuery(this).find('.js-servicepack-price').text(co3.util.formatNumber(data.Data.Gold));
                            }
                        });
                    }
                },
                init: function (data) {
                    master.serviceBooking.calculator.builder.mainInfo(data);
                    master.serviceBooking.calculator.builder.extras(data);
                    if ((jQuery('.js-service-calculator-extra-transmissions').is(':checked') || jQuery('.js-service-calculator-extra-systems').is(':checked'))) {
                        master.serviceBooking.calculator.builder.packages(data);
                    }
                }
            },
            /** @function */
            /**
             * Show package modal info
             */
            packageInfo: function () {
                jQuery('.js-servicepack-info').on('click', function () {
                    jQuery('.js-booking-package-info').modal();
                });
            },
            saveBookedData: function () {
                $('#master-service-bookservice-form').on('submit', function () {
                    var dateSelected = $('.js-bookservice-datepicker-panel-result').val();
                    var hourSelected = $('.js-bookservice-timepicker-panel-result').val();
                    var dropOffSelect = $('.js-booking-drop-off-time').val();
                    var pickUpSelect = $('.js-booking-pickup-time').val();

                    var dataObj = {
                        'dateSelected': dateSelected,
                        'hourSelected': hourSelected,
                        'dropOffSelect': dropOffSelect,
                        'pickUpSelect': pickUpSelect
                    };
                    sessionStorage.setItem('selectedTimes', JSON.stringify(dataObj));
                    return dataObj;
                });
            },
            init: function () {
                master.serviceBooking.calculator.fetch();
                master.serviceBooking.calculator.clear();
                master.serviceBooking.calculator.packageInfo();
                master.serviceBooking.calculator.saveBookedData();
            }
        },
        /**
         * @namespace
         * @property {Array} forcedOpenDays
         */
        calendar: {
            forcedOpenDays: [],
            /** @function */
            /**
             * Compile disabled dates, based on danish holidays, forced open day / vactions (from workshop admin)
             */
            compileDates: function () {
                var disabledDates = this.holidays();
                Array.prototype.removeDate = function () {
                    var what, a = arguments,
                        L = a.length,
                        ax;
                    while (L && this.length) {
                        what = a[--L];
                        while ((ax = this.indexOf(what)) !== -1) {
                            this.splice(ax, 1);
                        }
                    }
                    return this;
                };
                for (var i = 0; i < master.serviceBooking.calendar.forcedOpenDays.length; i++) {
                    if (jQuery.inArray(master.serviceBooking.calendar.forcedOpenDays[i], disabledDates) !== -1) {
                        disabledDates.removeDate(master.serviceBooking.calendar.forcedOpenDays[i]);
                    }
                }
                return disabledDates;
            },
            /** @function */
            /**
             * Compile danish holidays (found in /Templates/Designs/ftzmaster/assets/data/holidays_da.json - should work until 2027)
             */
            holidays: function () {
                var that = this,
                    holidays = JSON.parse(localStorage.getItem('master-holidays-v2')),
                    holidaysArr = [],
                    disabledArr = [];
                jQuery.each(holidays, function (index, holiday) {
                    var startDate = moment(holiday.date_start).format(master.settings.booking.dateFormat);
                    if (jQuery.inArray(startDate, master.serviceBooking.globals.disabledDates) === -1) {
                        holidaysArr.push(startDate);
                    }
                });
                disabledArr = master.serviceBooking.globals.disabledDates.concat(holidaysArr);
                if (jQuery('.js-booking-workshop-vacations').length) {
                    disabledArr = disabledArr.concat(that.vacations(jQuery.trim(jQuery('.js-booking-workshop-vacations').html().replace(/\./g, ','))));
                }
                disabledArr = disabledArr.sort(function (date1, date2) {
                    return new Date(date1) - new Date(date2);
                });
                return disabledArr;
            },
            /** @function */
            /**
             * Compile forced close days / vacation from workshop admin
             * @param {object} vacations
             */
            vacations: function (vacations) {
                var vacationsArr = JSON.parse(vacations),
                    disabledArr = [];
                for (var i = 0; i < vacationsArr.length; i++) {
                    if (vacationsArr[i].length === 1) {
                        if (vacationsArr[i][0].type === 'isCloseDay') {
                            disabledArr.push(moment(vacationsArr[i][0].start).format(master.settings.booking.dateFormat));
                        }
                        else {
                            this.forcedOpenDays.push(moment(vacationsArr[i][0].start).format(master.settings.booking.dateFormat));
                        }
                    }
                    else if (vacationsArr[i].length > 1) {
                        for (var o = 0; o < vacationsArr[i].length; o++) {
                            if (vacationsArr[i][o].type === 'isCloseDay') {
                                disabledArr.push(moment(vacationsArr[i][o].start).format(master.settings.booking.dateFormat));
                            }
                            else {
                                this.forcedOpenDays.push(moment(vacationsArr[i][o].start).format(master.settings.booking.dateFormat));
                            }
                        }
                    }
                }
                return disabledArr;
            },
            /** @function */
            /**
             * Setup datepicker
             */
            settings: function () {
                jQuery.fn.datepicker.dates.da = {
                    days: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    daysMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                    months: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
                    today: 'I dag',
                    clear: 'Nulstil',
                    format: 'dd-mm-yyyy',
                    titleFormat: 'MM yyyy',
                    weekStart: 1
                };
            },
            /** @function */
            /**
             * Toggle enable / disable
             */
            toggle: function () {
                jQuery('.js-bookservice-datepicker-panel-toggle').on('click', function () {
                    
                    if (!jQuery(this).is('.disabled')) {
                        master.serviceBooking.testForMismatchedWorkshopId(function(){
                            jQuery('.js-date-time-backdrop').toggle();
                            jQuery('.js-bookservice-datepicker-panel').toggle();
                            jQuery('.js-bookservice-timepicker-panel').hide();
                        });
                    }
                });
            },
            /** @function */
            /**
             * Update calender
             * @param {DateTime} startDate
             */
            update: function (startDate) {
                master.serviceBooking.globals.disabledDates = this.compileDates();
                var selectedDate = startDate;
                if (master.serviceBooking.globals.selectedDate && moment(master.serviceBooking.globals.selectedDate, master.settings.booking.dateFormat).isAfter(moment(startDate, master.settings.booking.dateFormat))) {
                    selectedDate = master.serviceBooking.globals.selectedDate;
                }
                jQuery('.js-bookservice-datepicker-panel-result').val('').removeClass('error').prop('placeholder', '--/--');
                jQuery('.js-bookservice-timepicker-panel-result').val('').removeClass('error');
                jQuery('.js-bookservice-datepicker-panel-toggle').removeClass('disabled');
                var jDatepicker = jQuery('.js-datepicker');
                jDatepicker.datepicker('setStartDate', startDate);
                jDatepicker.datepicker('setDatesDisabled', master.serviceBooking.globals.disabledDates);
                jDatepicker.datepicker('update', selectedDate).trigger('changeDate');
                jQuery('.js-bookservice-sidebar-panel.no-available-dates').removeClass('disabled no-available-dates').prop('disabled', false);
            },
            /** @function */
            /**
             * Disable calender
             */
            disable: function () {
                master.serviceBooking.globals.disabledDates = [];
                jQuery('.js-bookservice-sidebar-panel').addClass('disabled no-available-dates').prop('disabled', true);
                jQuery('.js-bookservice-datepicker-panel-toggle').addClass('disabled');
                jQuery('.js-bookservice-datepicker-panel-result').addClass('error').val('').prop('placeholder', jQuery('.js-bookservice-datepicker-panel-result').data('error'));
                jQuery('.js-bookservice-timepicker-panel-result').addClass('error').val('');
            },
            /** @function */
            /**
             * Get month from serverside service and handle the response by checking first availeble timeslots, if this day in the month should be added to disabled days
             * @param {object} data
             * @async
             */
            getMonth: function (data) {
                if (data.Data !== null) {
                    var jData = data.Data.Days,
                        startDate = '',
                        nullCheckArr = [];
                    jQuery.each(jData, function (index, jObj) {
                        var jDateTime = moment(jObj.DateTime).format(master.settings.booking.dateFormat);
                        if (jObj.FirstAvailableTimeslot === null) {
                            nullCheckArr.push(jObj.FirstAvailableTimeslot);
                        }
                        if ((jObj.AutoBooked === true) || (jObj.HasAvailableTimeslots === false) || (master.serviceBooking.globals.increntalcar === true && jObj.RentalCarAvailable === false)) {
                            if (jQuery.inArray(jDateTime, master.serviceBooking.globals.disabledDates) === -1) {
                                master.serviceBooking.globals.disabledDates.push(jDateTime);
                            }
                        }
                        else {
                            if (startDate === '' && jQuery.inArray(jDateTime, master.serviceBooking.globals.disabledDates) === -1) {
                                startDate = jDateTime;
                            }
                        }
                        if (jObj.FirstAvailableTimeslot !== null && jObj.HasAvailableTimeslots === true && startDate === '' && jQuery.inArray(jDateTime, master.serviceBooking.globals.disabledDates) === -1) {
                            startDate = jDateTime;
                        }
                    });
                    master.serviceBooking.calendar.update(startDate);
                    if (nullCheckArr.length === jData.length) {
                        master.serviceBooking.calendar.disable();
                    }
                }
            },
            /** @function */
            /**
             * Init calender and bind change date event
             */
            init: function () {
                this.settings();
                this.toggle();
                var jDatepicker = jQuery('.js-datepicker');
                jDatepicker.datepicker({
                    language: 'da',
                    startDate: master.serviceBooking.globals.today,
                    toggleActive: false,
                    todayHighlight: true,
                    calendarWeeks: true,
                    maxViewMode: 0,
                    //daysOfWeekDisabled: '0,6',
                    datesDisabled: []
                }).on('changeDate', function () {
                    var formattedDate = jDatepicker.datepicker('getFormattedDate'),
                        formattedTime = jQuery('.js-bookservice-timepicker-panel').find('.js-timeslots-item:not(.disabled)').first().end().find('input[type="radio"]').val() || '';
                    if (formattedDate) {
                        master.serviceBooking.globals.selectedDate = formattedDate;
                    }
                    jQuery('.js-service-date').val(formattedDate + ' ' + formattedTime);
                    jQuery('.js-bookservice-datepicker-panel-result').val(formattedDate);
                    //jQuery( '.js-bookservice-timepicker-panel-result' ).val( formattedTime );
                    jQuery('.js-bookservice-datepicker-panel').hide();
                    jQuery('.js-date-time-backdrop').hide();
                    jQuery('.js-bookservice-timepicker-panel').fadeOut(master.settings.animateSpeed, function () {
                        jQuery(this).html('');
                        master.serviceBooking.api.booking('getday', formattedDate, master.serviceBooking.timeslot.check);
                    });
                }).trigger('changeDate');
            }
        },
        /**
         * @namespace
         */
        timeslot: {
            /**
             * @namespace
             * @property {object} settings
             */
            builder: {
                settings: {
                    startOfWeek: 1,
                    minTime: 0,
                    maxTime: 0,
                    numSlots: 0,
                    requested: 0,
                    daynum: 0
                },
                /** @function */
                /**
                 * Convert timeslot time to datetime
                 * @param {string} time
                 * @return {date}
                 */
                timeslotTime: function (time) {
                    var timeParts = time.split(':'),
                        d = new Date();
                    d.setHours(timeParts[0]);
                    d.setMinutes(timeParts[1]);
                    d.setSeconds(timeParts[2]);
                    return d;
                },
                /** @function */
                /**
                 * Convert timeslot time to datetime
                 * @param {datetime} startDate
                 * @param {datetime} endDate
                 * @param {number} interval
                 * @return {array}
                 */
                timeslotConvert: function (startDate, endDate, interval) {
                    var slots = [],
                        intervalMillis = interval * 60 * 1000;
                    while (startDate <= endDate) {
                        var mins = (startDate.getMinutes() + '0').slice(0, 2);
                        slots.push(startDate.getHours() + ':' + mins);
                        startDate.setTime(startDate.getTime() + intervalMillis);
                    }
                    return slots;
                },
                /** @function */
                /**
                 * Build timeslot picker and merge data for pickup/dropoff select-boxes
                 */
                build: function () {
                    var bookingInterval = jQuery('.js-workshop-booking-interval').text();
                    var slots = this.timeslotConvert(this.timeslotTime(this.settings.minTime), this.timeslotTime(this.settings.maxTime), bookingInterval),
                        timeWrap = jQuery('.js-bookservice-timepicker-panel'),
                        workshopTimeslots = jQuery('.js-workshop-delivery-hours').find('.js-workshop-delivery-hour[data-index="' + (this.settings.daynum - 1) + '"]').text(),
                        deliverySlots = [];
                    for (var i = 0; i < slots.length; i++) {
                        var intervalClass = 'interval-' + master.settings.booking.timeslotGap,
                            timeslotClass = 'timeslot-' + slots[i].substring(slots[i].indexOf(':') + 1);
                        if ((i + 1) === slots.length) {
                            timeWrap.append('<label class="radio disabled closing-time ' + intervalClass + ' ' + timeslotClass + '"><input type="radio" name="BookingOensketTidspunkt" id="optionsRadios' + i + '" value="' + slots[i] + '" required> ' + slots[i] + ' </label>');
                        }
                        else {
                            timeWrap.append('<label class="radio js-timeslots-item ' + intervalClass + ' ' + timeslotClass + '" data-timeslot="' + moment(slots[i], 'H:mm:ss').format('HH:mm:ss') + '"><input type="radio" name="BookingOensketTidspunkt" id="optionsRadios' + i + '" value="' + slots[i] + '" required> ' + slots[i] + ' </label>');
                        }
                    }
                    if (workshopTimeslots !== 'X') {
                        var extraTimeslots = moment.duration(workshopTimeslots),
                            openingHourIndex = moment.duration(slots[0]),
                            extraMinutes = extraTimeslots._data.minutes === 0 ? '00' : extraTimeslots._data.minutes;
                        deliverySlots.push(extraTimeslots._data.hours + ':' + extraMinutes);
                        var ix = 0;
                        while (((extraTimeslots._data.hours + extraTimeslots._data.minutes) !== (openingHourIndex._data.hours + openingHourIndex._data.minutes)) && ix < 50) {
                            var minutes = '';
                            extraTimeslots = moment.duration(extraTimeslots).add(bookingInterval, 'minutes');
                            if (extraTimeslots._data.minutes === 0) {
                                minutes = '00';
                            }
                            else {
                                minutes = extraTimeslots._data.minutes;
                            }
                            if (jQuery.inArray(extraTimeslots._data.hours + ':' + minutes, deliverySlots) < 0) {
                                deliverySlots.push(extraTimeslots._data.hours + ':' + minutes);
                            }
                            ix++;
                        }
                    }
                    var mergedTimeslots = deliverySlots.concat(slots);
                    master.serviceBooking.pickupDropoff.data = mergedTimeslots;
                    master.serviceBooking.pickupDropoff.daynum = this.settings.daynum;
                    master.serviceBooking.pickupDropoff.requested = this.settings.requested;
                    //timeWrap.find( 'input[type="radio"]:not(.disabled)' ).first().trigger( 'click' );
                    master.serviceBooking.pickupDropoff.build();
                },
                init: function (jData) {
                    this.settings.minTime = jData.OpenTime;
                    this.settings.maxTime = jData.CloseTime;
                    this.settings.numSlots = jData.TotalIntervals;
                    this.settings.requested = jData.RequestedTimeslots;
                    this.settings.daynum = jData.DayOfWeek;
                    this.build();
                }
            },
            /** @function */
            /**
             * Find available timeslot by check up against available employees, by calculating their timespans and occurences. Excludes rental cars
             */
            find: function (data) {

                // Get data object.
                var jData = data.Data,
                    employeeObj = {},
                    bookedTimeslotsArr = [],
                    rentalCarsArr = jData.RentalCarIds,
                    totalIntervals = jData.TotalIntervals;
                //console.log('Planner data', jData);
                //console.log('Iterating Planner data Timeslots');
                /* Iterating Planner data Timeslots and build Employee Object */

                for (var j = 0; j < jData.EmployeeIds.length; j++) {

                    if (jData.EmployeeIds[j] !== -1 && jQuery.inArray(jData.EmployeeIds[j], rentalCarsArr) === -1) {
                        employeeObj[jData.EmployeeIds[j]] = [];
                        for (var i = 1; i <= totalIntervals; i++) {
                            employeeObj[jData.EmployeeIds[j]].push('available');
                        }
                    }

                }
                if (Object.keys(employeeObj).length > 0) {
                    //console.log('Iterating Planner data Timeslots');
                    /* Iterating Planner data Timeslots, and finding all intervals an employee is booked, removing double bookings - adding to Employee Object */
                    jQuery.each(jData.Timeslots, function (index, timeslot) {
                        for (var i = parseInt(timeslot.IntervalStart) - 1; i <= parseInt(timeslot.IntervalEnd) - 1; i++) {
                            if (jQuery.inArray(i, employeeObj[timeslot.EmployeeId]) === -1) {
                                if (timeslot.EmployeeId !== -1 && jQuery.inArray(timeslot.EmployeeId, rentalCarsArr) === -1) {
                                    if (timeslot.isPause) {
                                        employeeObj[timeslot.EmployeeId][i] = 'pause';
                                    }
                                    else {
                                        employeeObj[timeslot.EmployeeId][i] = 'booked';

                                    }
                                }


                            }
                        }

                    });
                    var requestedTimeslots = jData.RequestedTimeslots;
                    var AvailableTimeslotsArr = [];
                    for (var i = 1; i <= totalIntervals; i++) {
                        AvailableTimeslotsArr.push(false);
                    }
                    //foreach employee check which timeslots are available - combine into AvailableTimeslotsArr. 
                    jQuery.each(employeeObj, function (Employee, bookings) {
                        var availableSlots = 0;
                        for (var i = totalIntervals - 1; i >= 0; i--) {

                            if (bookings.length>0 && bookings[i].localeCompare('available')==0) {
                                availableSlots = availableSlots+1;
                                if (availableSlots >= requestedTimeslots) {
                                    AvailableTimeslotsArr[i] = true;
                                }
                            }
                            else if (bookings[i].localeCompare('booked') === 0) {
                                availableSlots = 0;
                            }
                            //else if pause, do not change availableTimeslots


                        }


                    });

                    var arrayLength = AvailableTimeslotsArr.length;
                    for (var k = 0; k < arrayLength; k++) {
                        bookedTimeslotsArr[k] = !AvailableTimeslotsArr[k];
                    }
                }
                return bookedTimeslotsArr;
            },
            /** @function */
            /**
             * Check if the request is possible
             * @param {object} jData
             * @return {boolean}
             */
            isRequestPossible: function (jData) {
                var requested = parseInt(jData.RequestedTimeslots),
                    total = parseInt(jData.TotalIntervals),
                    booked = 0,
                    result = 0;
                for (var i = 0; i < jData.Timeslots.length; i++) {
                    booked = booked + parseInt(jData.Timeslots[i].Intervals);
                }
                result = (total - booked) <= requested ? false : true;
                return true;
            },
            /** @function */
            /**
             * Clear timepicker
             */
            clear: function () {
                jQuery('.js-bookservice-timepicker-panel').html('');
            },
            /** @function */
            /**
             * If request is not possible, we check the next day
             * @param {object} jData
             */
            checkNextDay: function (jData) {
                var jDateTime = moment(jData.DateTime);
                master.serviceBooking.globals.disabledDates.push(jDateTime.format(master.settings.booking.dateFormat));
                if (master.serviceBooking.globals.dateLoopCounter < 20) {
                    master.serviceBooking.calendar.update(jDateTime.add(1, 'days').format(master.settings.booking.dateFormat));
                    //master.serviceBooking.api.booking( 'getday', jDateTime.add( 1, 'days' ).format( master.settings.booking.dateFormat ), master.serviceBooking.timeslot.check );
                    master.serviceBooking.globals.dateLoopCounter++;
                }
            },
            /** @function */
            /**
             * Logging error
             */
            dateLoopError: function () {
                master.utils.log('No dates available right now', 'error');
            },
            /** @function */
            /**
             * Here we make a lot of checking to see if it is possible to book the timeslot.
             * @param {object} data
             */
            check: function (data) {
                var jData = data.Data,
                    jPanel = jQuery('.js-bookservice-timepicker-panel');
                jQuery('.js-bookservice-timepicker-panel-result').val('');
                if ((jData.OpenTime === jData.CloseTime) === true) {
                    master.serviceBooking.timeslot.checkNextDay(jData);
                }
                else if (master.serviceBooking.globals.increntalcar === true && (jData.RentalCarAvailable === null || jData.RentalCarAvailable !== true)) {
                    master.serviceBooking.timeslot.checkNextDay(jData);
                }
                else {
                    master.serviceBooking.timeslot.courtesyCarAvailable(jData);
                    if (jData !== null && jData.EmployeeIds !== undefined && jData.EmployeeIds.length) {
                        if (jData.FirstAvailableTimeslot !== null) {
                            if (jData.HasAvailableTimeslots === true && master.serviceBooking.timeslot.isRequestPossible(jData) === true && jData.FirstAvailableTimeslot.IntervalEnd <= jData.TotalIntervals) {
                                master.serviceBooking.globals.dateLoopCounter = 0;
                                var bookedTimeslots = master.serviceBooking.timeslot.find(data);
                                jPanel.find('input[type="radio"]').prop('disabled', false).parent().removeClass('disabled');
                                master.serviceBooking.timeslot.builder.init(jData);
                                if (jData.HasAvailableTimeslots === true && bookedTimeslots.length > 0) {
                                    master.serviceBooking.timeslot.handler(jData, bookedTimeslots);
                                }
                                else {
                                    master.serviceBooking.timeslot.handler(jData, false);
                                }
                                jPanel.on('click', 'input[type="radio"][id="time-option-nexttime"]', function () {
                                    jQuery('.js-service-date').val(master.serviceBooking.globals.selectedDate + ' ' + jQuery(this).find('input').val());
                                    jQuery('.js-service-employee-id').val(jData.FirstAvailableTimeslot.EmployeeId);
                                });
                                jPanel.on('click', '.js-timeslots-item:not(.disabled)', function () {
                                    jPanel.find('.js-timeslots-item, .closing-time').removeClass('active spanslot last-timeslot');
                                    jQuery('.js-service-date').val(master.serviceBooking.globals.selectedDate + ' ' + jQuery(this).find('input').val());
                                    jQuery('.js-service-employee-id').val(jData.FirstAvailableTimeslot.EmployeeId);
                                    jQuery('.js-bookservice-timepicker-panel-result').val(jQuery(this).find('input').val());
                                    jQuery('.js-bookservice-timepicker-panel').hide();
                                    jQuery('.js-date-time-backdrop').hide();
                                    jQuery(this).addClass('active').nextAll().slice(0, master.serviceBooking.globals.timeslots.total).addClass('spanslot').slice((master.serviceBooking.globals.timeslots.total - 1), master.serviceBooking.globals.timeslots.total).addClass('last-timeslot');
                                    master.serviceBooking.pickupDropoff.build();
                                });
                                jQuery('.js-service-employee-id').val(jData.FirstAvailableTimeslot.EmployeeId);
                                setTimeout(function () {
                                    if (jData.FirstAvailableTimeslot.EmployeeId !== parseInt(jQuery('.js-service-employee-id').val())) {
                                        jQuery('.js-service-employee-id').val(jData.FirstAvailableTimeslot.EmployeeId);
                                    }
                                }, 1000);
                            }
                            else {
                                master.serviceBooking.timeslot.checkNextDay(jData);
                            }
                        }
                        else {
                            master.serviceBooking.timeslot.checkNextDay(jData);
                        }
                        //jPanel.find( '.js-timeslots-item:not(.disabled)' ).first().trigger( 'click' );
                    }
                    else {
                        master.serviceBooking.timeslot.noEmployeeHandler(data);
                    }
                }
            },
            /** @function */
            /**
             * If there are no employees (aka no FTZ+) we run this
             */
            noEmployeeHandler: function (data) {
                var jData = data.Data,
                    jPanel = jQuery('.js-bookservice-timepicker-panel');
                if (jData !== null) {
                    jQuery('.js-bookservice-timepicker-panel').find('input[type="radio"]').prop('disabled', false).parent().removeClass('disabled');
                    master.serviceBooking.timeslot.builder.init(jData);
                    if (jData.HasAvailableTimeslots === true) {
                        master.serviceBooking.timeslot.handler(jData, false);
                        jPanel.on('click', 'input[type="radio"][id="time-option-nexttime"]', function () {
                            var jDateTime = moment(jData.DateTime).format(master.settings.booking.dateFormat);
                            jQuery('.js-service-date').val(jDateTime + ' ' + jData.FirstAvailableTimeslot.StartTime);
                            jQuery('.js-service-employee-id').val(jData.FirstAvailableTimeslot.EmployeeId);
                        });
                        jPanel.on('click', '.js-timeslots-item:not(.disabled)', function () {
                            var jDateTime = moment(jData.DateTime).format(master.settings.booking.dateFormat);
                            jPanel.find('.js-timeslots-item, .closing-time').removeClass('active');
                            jQuery('.js-service-date').val(jDateTime + ' ' + jQuery(this).find('input').val());
                            jQuery('.js-service-employee-id').val(jData.FirstAvailableTimeslot.EmployeeId);
                            jQuery('.js-bookservice-timepicker-panel-result').val(jQuery(this).find('input').val());
                            jQuery('.js-bookservice-timepicker-panel').hide();
                            jQuery('.js-date-time-backdrop').hide();
                            jQuery(this).addClass('active');
                            jQuery(this).nextAll().slice(0, master.serviceBooking.globals.timeslots.total).slice((master.serviceBooking.globals.timeslots.total - 1), master.serviceBooking.globals.timeslots.total);
                            master.serviceBooking.pickupDropoff.build();
                        });
                    }
                }
            },
            /** @function */
            /**
             * Handle booked timeslots and disable them in timepicker.
             * If date is today, we disable all timeslots that lies before now, then we use the booked timeslots array and uses the indexes to disabled booked timeslots
             * @param {object} jData
             * @param {array} bookedTimeslots
             */
            handler: function (jData, bookedTimeslots) {
                var firstAvail = moment(jData.FirstAvailableTimeslot.StartTime, 'H:mm:ss').format('HH:mm:ss');
                jQuery('.js-bookservice-timepicker-panel').find('.js-timeslots-item[data-timeslot="' + firstAvail + '"]').prevAll('.js-timeslots-item').addClass('disabled booked').find('input[type="radio"]').prop({
                    'disabled': true,
                    'checked': false
                });
                if (bookedTimeslots !== false) {
                    for (var i = 0; i <= bookedTimeslots.length; i++) {
                        if (bookedTimeslots[i]) {
                            jQuery('.js-bookservice-timepicker-panel').find('.js-timeslots-item').eq(((i))).addClass('disabled booked').find('input[type="radio"]').prop({
                                'disabled': true,
                                'checked': false
                            });
                        }

                    }
                }

                var savedData = sessionStorage.getItem('selectedTimes');
                var data = JSON.parse(savedData);
                if (savedData) {
                    var savedHour = data.hourSelected.charAt(0) !== '0' && data.hourSelected.length === 4 ? '0' + data.hourSelected + ':00' : data.hourSelected + ':00';
                    setTimeout(function () {
                        var element = document.querySelector('[data-timeslot="' + savedHour + '"]');

                        element.click();
                    }, 1500)
                }

            },
            /** @function */
            /**
             * Check if car is available
             * @param {object} data
             */
            courtesyCarAvailable: function (data) {
                var rentalCarPrice = '( ' + co3.util.formatNumber(data.RentalCarPrice) + ',- ';
                jQuery('.js-courtesy-car').prop('disabled', false).next('label').attr('data-rental-price', rentalCarPrice + ' pr. dag )');
                if (master.serviceBooking.globals.increntalcar === true) {
                    jQuery('.js-service-bookservice-rentalcar-name').val(data.RentalCarName);
                }
                else {
                    jQuery('.js-service-bookservice-rentalcar-name').val('');
                }
            },
            /** @function */
            /**
             * Toggle panels
             */
            toggle: function () {
                jQuery('.js-bookservice-timepicker-panel-toggle').on('click', function () {
                    jQuery('.js-date-time-backdrop').toggle();
                    jQuery('.js-bookservice-timepicker-panel').toggle();
                });
            },
            /** @function */
            /**
             * hide panels
             */
            backdrop: function () {
                jQuery('.js-date-time-backdrop').on('click', function () {
                    jQuery('.js-bookservice-timepicker-panel').hide();
                    jQuery('.js-bookservice-datepicker-panel').hide();
                    jQuery(this).hide();
                });
            },
            init: function () {
                this.toggle();
                this.backdrop();
            }
        },
        /**
         * @namespace
         * @property {array} data
         * @property {number} daynum
         * @property {number} requested
         */
        pickupDropoff: {
            data: [],
            daynum: 0,
            requested: 0,
            /** @function */
            /**
             * Build the selectboxes for drop-off and pick-up
             */
            build: function () {
                var jDropoffSelect = jQuery('.js-booking-drop-off-time'),
                    jPickupSelect = jQuery('.js-booking-pickup-time'),
                    jOptionDropoffMarkup = '',
                    jOptionPickupMarkup = '',
                    timeslots = this.data;
                jDropoffSelect.html('');
                jPickupSelect.html('');

                if (sessionStorage.getItem('selectedTimes') !== null) {
                    // jOptionDropoffMarkup += '<option selected >' + JSON.parse(sessionStorage.getItem('selectedTimes')).dropOffSelect + '</option>';
                    jOptionDropoffMarkup += '<option disabled>' + jDropoffSelect.data('select-text') + '</option>';
                } else {
                    jOptionDropoffMarkup += '<option selected disabled>' + jDropoffSelect.data('select-text') + '</option>';
                }

                jOptionDropoffMarkup += '<option value="' + jDropoffSelect.data('night-text') + '">' + jDropoffSelect.data('night-text') + '</option>';
                jOptionPickupMarkup += '<option disabled>' + jDropoffSelect.data('select-text') + '</option>';
                for (var i = 0; i < timeslots.length; i++) {
                    var isSelectedAttr = '';

                    if (sessionStorage.getItem('selectedTimes') !== null) {
                        isSelectedAttr = JSON.parse(sessionStorage.getItem('selectedTimes')).dropOffSelect === timeslots[i] ? 'selected' : '';
                        var isPickupSelected = JSON.parse(sessionStorage.getItem('selectedTimes')).pickUpSelect === timeslots[i] ? 'selected' : '';

                    } else {
                        var isPickupSelected = i === (timeslots.length - 1) ? 'selected' : '';
                    }

                    jOptionDropoffMarkup += '<option ' + isSelectedAttr + ' value="' + timeslots[i] + '">' + timeslots[i] + '</option>';
                    jOptionPickupMarkup += '<option ' + isPickupSelected + ' value="' + timeslots[i] + '">' + timeslots[i] + '</option>';
                }
                //jOptionPickupMarkup += '<option value="' + jPickupSelect.data( 'waitworkshop-text' ) + '">' + jPickupSelect.data( 'waitworkshop-text' ) + '</option>';
                jOptionPickupMarkup += '<option value="' + jPickupSelect.data('atworkshop-text') + '">' + jPickupSelect.data('atworkshop-text') + '</option>';
                // jOptionPickupMarkup += '<option class="js-booking-pickup-time-after" value="custom">' + jPickupSelect.data( 'after-text' ) + '</option>';
                jDropoffSelect.html(jOptionDropoffMarkup);
                jPickupSelect.html(jOptionPickupMarkup);
                this.disabler();
            },
            /** @function */
            /**
             * Disabled options based on selected timeslot (mainly the ones before selected timeslots).
             * If user has checked the wait-checkboks, we append an option with waiting
             */
            disabler: function () {
                var selectedTimeslot = jQuery('.js-bookservice-timepicker-panel').find('.js-timeslots-item.active input').val(),
                    workshopMaxTimeslot = jQuery('.js-workshop-delivery-hours').find('.js-workshop-delivery-end-hour[data-index="' + (this.daynum - 1) + '"]').text(),
                    isToday = moment(jQuery('input[name="ServiceDate"]').val(), 'DD-MM-YYYY H:mm:ss').isSame(new Date(), 'day'),
                    m = moment(),
                    currentTime = moment(m, 'H:mm');

                if (workshopMaxTimeslot !== 'X') {
                    workshopMaxTimeslot = workshopMaxTimeslot.substring(0, 1) === '0' ? workshopMaxTimeslot.replace(workshopMaxTimeslot.substring(0, 1), '') : workshopMaxTimeslot;
                    jQuery('.js-booking-drop-off-time').find('option[value="' + workshopMaxTimeslot + '"]').nextAll().prop('disabled', true).hide();
                }
                jQuery('.js-booking-drop-off-time').find('option[value="' + selectedTimeslot + '"]').nextAll().prop('disabled', true).hide();
                //jQuery( '.js-booking-drop-off-time' ).find( 'option[value="' + selectedTimeslot + '"]' ).prop( 'selected', true );
                jQuery('.js-booking-pickup-time').find('option[value="' + selectedTimeslot + '"]').prevAll().prop('disabled', true).hide();
                var selectedIndex = jQuery('.js-booking-pickup-time').find('option[value="' + selectedTimeslot + '"]').index();
                for (var i = selectedIndex; i < (this.requested + selectedIndex); i++) {
                    jQuery('.js-booking-pickup-time').find('option').eq(i).prop('disabled', true).hide();
                }

                if (jQuery('.js-customer-wait').is(':checked') === true) {
                    jQuery('.js-booking-pickup-time').append('<option value="' + jQuery('.js-booking-pickup-time').data('waitworkshop-text') + '">' + jQuery('.js-booking-pickup-time').data('waitworkshop-text') + '</option>').prop({
                        disabled: true,
                        required: false
                    }).val('Venter på værkstedet');
                }

                if (isToday === true) {
                    jQuery('.js-booking-drop-off-time').find('option').each(function () {
                        var thisTime = moment(jQuery(this).val(), 'H:mm');
                        if (thisTime.isValid()) {
                            if (thisTime.isBefore(currentTime)) {
                                jQuery(this).prop('disabled', true).hide();
                            }
                        } else {
                            jQuery(this).prop('disabled', true).hide();
                        }
                    });
                    if (jQuery('.js-booking-drop-off-time').filter(function (option) { return jQuery(option).prop('disabled') === false }).length === 0) {
                        jQuery('.js-booking-drop-off-time').find('option[value="' + selectedTimeslot + '"]').prop('disabled', false).show();
                    }
                }

            },
            /** @function */
            /**
             * Event handlers
             */
            actions: function () {
                jQuery('.js-booking-drop-off-time').on('change', function () {
                    if (jQuery(this)[0].selectedIndex === 1) {
                        jQuery('.js-booking-car-deposit-box').addClass('attention').one(master.settings.animationEnd, function () {
                            jQuery(this).removeClass('attention');
                        });
                    }
                });
                jQuery('.js-booking-pickup-time').on('change', function () {
                    if (jQuery(this).val() === 'custom') {
                        jQuery('.js-booking-pickup-time-custom').slideDown(master.settings.animateSpeed);
                    }
                    else {
                        jQuery('.js-booking-pickup-time-custom').slideUp(master.settings.animateSpeed).val('');
                    }
                });
            },
            init: function () {
                this.actions();
            }
        },
        /**
         * @namespace
         */
        cart: {
            /** @function */
            /**
             * Submit all selected service and build object to post to DW.
             * Different product-types uses different defered objects
             */
            submitter: function () {
                master.serviceBooking.testForMismatchedWorkshopId(function(){
                    var postObj = {};
                    jQuery('.js-bookservice-servicelist-item, .js-bookservice-servicelist-item-special-service').filter(':checked').not('.js-bookservice-servicelist-item-in-cart').each(function () {
                        var specialProductType = jQuery(this).data('special'),
                            jProductId = jQuery(this).val(),
                            jTimeslot = jQuery(this).data('timeslot');
                        if (specialProductType !== '' && specialProductType !== 'EXPRESS' && specialProductType !== 'HIGHLIGHT' && specialProductType !== 'CONTACT') {
                            if (specialProductType === 'OTHER') {
                                postObj.otherOrderline = master.serviceBooking.cart.promise(master.serviceBooking.cart.defers.otherOrderline(jProductId, jTimeslot));
                            }
                            else if (specialProductType === 'SERVICECALCULATOR') {
                                postObj.calculatedOrderline = master.serviceBooking.cart.promise(master.serviceBooking.cart.defers.calculatedOrderline(jProductId));
                            }
                        }
                        else {
                            postObj[jProductId] = master.serviceBooking.cart.promise(master.serviceBooking.cart.defers.standardOrderline(jProductId, jTimeslot));
                        }
                    });

                    jQuery('.js-bookservice-servicelist-item, .js-bookservice-servicelist-item-special-service').filter(':checked').each(function () {
                        var specialProductType = jQuery(this).data('special'),
                            jProductId = jQuery(this).val(),
                            jTimeslot = jQuery(this).data('timeslot');
                        if (specialProductType !== '' && specialProductType !== 'EXPRESS' && specialProductType !== 'HIGHLIGHT' && specialProductType !== 'CONTACT') {
                            if (specialProductType === 'OTHER') {
                                postObj.otherOrderline = master.serviceBooking.cart.promise(master.serviceBooking.cart.defers.otherOrderline(jProductId, jTimeslot));
                            }
                        }
                    });
                    postObj.orderDetails = master.serviceBooking.cart.promise(master.serviceBooking.cart.defers.orderDetails(), false);
                    master.serviceBooking.globals.addToCart.push(postObj);
                    master.serviceBooking.cart.queue(master.serviceBooking.globals.addToCart, jQuery('.js-service-checkout-redirect').val());
                });
            },
            /** @function */
            /**
             * Build the deffered queue and run
             */
            queue: function (postArr, redirect) {
                var queue = jQuery.when.apply($, postArr);
                queue.done(function () {
                    if (redirect === 'reload') {
                        //console.log( 'booking queue reload' )
                        location.reload();
                    }
                    else {
                        master.serviceBooking.edit.save();
                        location.href = redirect;
                    }
                });
            },
            /** @function */
            /**
             * Validate the booking form
             */
            validate: function () {
                master.serviceBooking.selectors.form.validate({
                    errorLabelContainer: '.js-bookservice-validation-errors',
                    wrapper: 'ul',
                    errorElement: 'li',
                    invalidHandler: function () {
                        master.utils.preloader(false);
                        co3.util.scroll.toElement(jQuery('.js-service-bookservice-form'), 0, true, true);
                    },
                    submitHandler: function () {
                        master.utils.preloader(true);
                        setTimeout(function () {
                            master.serviceBooking.testForMismatchedWorkshopId(master.serviceBooking.cart.submitter)
                        }, 200);
                        return false;
                    }
                });
            },
            /** @function */
            /**
             * Return a promise of the service item
             * @param {object} dataObj
             * @return {object}
             */
            promise: function (dataObj) {
                return jQuery.ajax({
                    data: dataObj,
                    beforeSend: function () {
                        master.utils.preloader(true);
                    },
                    async: false,
                    type: 'POST',
                    url: location.href
                });
            },
            /**
             * @namespace
             */
            defers: {
                /** @function */
                /**
                 * Return deleted orderline ajax object
                 * @param {string} jProductId
                 * @return {object}
                 */
                deleteOrderline: function (jProductId) {
                    var jOrderlineNumber = jQuery('.js-service-booking-orderlines').find('.js-service-booking-orderline[data-product-id="' + jProductId + '"]').data('orderline-id'),
                        postObj = {
                            CartCmd: 'DelOrderLine',
                            key: jOrderlineNumber
                        };
                    return postObj;
                },
                /** @function */
                /**
                 * Return order details object
                 * @return {object}
                 */
                orderDetails: function () {
                    var postObj = {
                        ServiceDate: jQuery('.js-service-date').val(),
                        LicensePlate: jQuery('.js-module-licenseplate-lookup-input').val(),
                        ServiceEmployeeID: jQuery('.js-service-employee-id').val(),
                        ServiceRentalcarID: jQuery('.js-service-rental-car-id').val(),
                        RentalcarName: jQuery('.js-service-bookservice-rentalcar-name').val(),
                        WorkshopID: jQuery('input[name="WorkshopID"]').val(),
                        CourtesyCar: jQuery('.js-courtesy-car').is(':checked') ? true : '',
                        customerWait: jQuery('.js-customer-wait').is(':checked') ? true : '',
                        CustomerDropoffTime: jQuery('.js-booking-drop-off-time').val(),
                        CustomerPickupTime: jQuery('.js-booking-pickup-time-custom').is(':visible') ? 'Andet: ' + jQuery('.js-booking-pickup-time-custom').val() : jQuery('.js-booking-pickup-time').val()
                    };
                    return postObj;
                },
                /** @function */
                /**
                 * Return a standard service item object add to cart
                 * @return {object}
                 */
                standardOrderline: function (jProductId, jTimeslot) {
                    var shouldAdd = jQuery('.js-service-booking-orderline[data-product-id="' + jProductId + '"]').length === 0;
                    var postObj = {
                        CartCmd: 'add',
                        ProductID: jProductId,
                        EcomOrderLineFieldInput_Timeslot: jTimeslot,
                        Quantity: shouldAdd === true ? 1 : 0
                    };                    
                    return postObj;
                },
                /** @function */
                /**
                 * Return the 'other' service item object add to cart
                 * @return {object}
                 */
                otherOrderline: function (jProductId, jTimeslot) {
                    var shouldAdd = jQuery('.js-service-booking-orderline[data-product-id="' + jProductId + '"]').length === 0;
                    var postObj = {
                        CartCmd: 'add',
                        ProductID: jProductId,
                        EcomOrderLineFieldInput_Timeslot: jTimeslot,
                        EcomOrderLineFieldInput_Comment: jQuery('.js-bookservice-other-textarea').val(),
                        Quantity: shouldAdd === true ? 1 : 0
                    };
                    return postObj;
                },
                /** @function */
                /**
                 * Return the service-calculator service item object add to cart
                 * @return {object}
                 */
                calculatedOrderline: function (jProductId) {
                    var shouldAdd = jQuery('.js-service-booking-orderline[data-product-id="' + jProductId + '"]').length === 0;
                    var postObj = {
                        CartCmd: 'add',
                        ProductID: jProductId,
                        EcomOrderLineFieldInput_ServiceID: jQuery('.js-bookservice-panel-service-calculator-carinfo-service-id').val(),
                        EcomOrderLineFieldInput_Stelnr: jQuery('.js-bookservice-panel-service-calculator-carinfo-stelnr').val(),
                        EcomOrderLineFieldInput_Price: jQuery('.js-bookservice-panel-service-calculator-carinfo-price').val(),
                        EcomOrderLineFieldInput_LicensePlate: jQuery('.js-module-licenseplate-lookup-input').val(),
                        EcomOrderLineFieldInput_Milage: jQuery('.js-bookservice-panel-service-calculator-carinfo-milage').val(),
                        EcomOrderLineFieldInput_regyear: jQuery('.js-bookservice-panel-service-calculator-carinfo-reg-date').val(),
                        EcomOrderLineFieldInput_transmissions: jQuery('input[name="EcomOrderLineFieldInput_transmissions"]').filter(':checked').val() || null,
                        EcomOrderLineFieldInput_systems: jQuery('input[name="EcomOrderLineFieldInput_systems"]').filter(':checked').val() || null,
                        EcomOrderLineFieldInput_WorkshopID: jQuery('input[name="WorkshopID"]').val(),
                        EcomOrderLineFieldInput_package: jQuery('.js-service-calculator-packages').filter(':checked').val() || null,
                        EcomOrderLineFieldInput_Timeslot: jQuery('.js-bookservice-panel-service-calculator-carinfo-timeslots').val(),
                        Quantity: shouldAdd === true ? 1 : 0
                    };
                    return postObj;
                }
            },
            /** @function */
            /**
             * Check the context of the cart
             */
            contextChecker: function () {
                if (jQuery('.js-service-booking-orderlines').data('cart-context') === 'False' && jQuery('.js-service-booking-orderlines').data('cart-empty') === 'False') {
                    jQuery('.js-checkout-context-modal').on('hide', function () {
                        master.serviceBooking.selectors.form.find('fieldset').addClass('disabled').prop('disabled', true);
                    }).modal('show');
                }
            },
            init: function () {
                this.validate();
                this.contextChecker();
            }
        },
        /**
         * @namespace
         */
        edit: {
            /** @function */
            /**
             * Save form to sessionstorage
             */
            save: function () {
                var jFormFields = ['.js-bookservice-other-textarea', '.js-bookservice-panel-service-calculator-carinfo-milage', '.js-bookservice-panel-service-calculator-carinfo-reg-date', '.js-bookservice-panel-service-calculator-carinfo-stelnr', '.js-bookservice-panel-service-calculator-carinfo-price', '.js-bookservice-panel-service-calculator-carinfo-timeslots', '.js-bookservice-panel-service-calculator-carinfo-service-id', '.js-service-employee-id', '.js-service-rental-car-id', '.js-service-date', '.js-courtesy-car:checked', '.js-customer-wait:checked', '.js-service-calculator-packages:checked', '.js-service-calculator-extra-transmissions:checked', '.js-service-calculator-extra-systems:checked', '.js-booking-drop-off-time', '.js-booking-pickup-time', '.js-booking-pickup-time-custom'],
                    preservedBookingForm = {};
                for (var i = 0; i < jFormFields.length; i++) {
                    var jElement = jQuery(jFormFields[i]);
                    preservedBookingForm[jElement.attr('name')] = {};
                    preservedBookingForm[jElement.attr('name')].type = jElement.attr('type');
                    preservedBookingForm[jElement.attr('name')].checked = jElement.prop('checked');
                    preservedBookingForm[jElement.attr('name')].value = jElement.val();
                    preservedBookingForm[jElement.attr('name')].text = jElement.data('text');
                }
                sessionStorage.preservedBookingForm = JSON.stringify(preservedBookingForm);
            },
            /** @function */
            /**
             * Load form from sessionstorage
             */
            load: function () {
                var jOrderlines = [],
                    preservedBookingForm = sessionStorage.preservedBookingForm !== undefined ? JSON.parse(sessionStorage.preservedBookingForm) : null;
                jQuery('.js-service-booking-orderlines').find('.js-service-booking-orderline').each(function () {
                    jOrderlines.push(jQuery(this).data('product-id'));
                });
                for (var i = 0; i < jOrderlines.length; i++) {
                    jQuery('.js-bookservice-servicelist-item[value="' + jOrderlines[i] + '"]').prop('checked', true).trigger('panel-toggle');
                }
                if (preservedBookingForm !== null) {
                    jQuery.each(preservedBookingForm, function (field, values) {
                        if (values.type === 'checkbox' || values.type === 'radio') {
                            jQuery('[name="' + field + '"][value="' + values.value + '"]').prop('checked', values.checked);
                        }
                        else {
                            jQuery('[name="' + field + '"]').val(values.value);
                        }
                    });
                    master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
                }
            },
            /** @function */
            /**
             * Clear edit sessionStorage
             */
            delete: function () {
                sessionStorage.removeItem('preservedBookingForm');
            },
            /** @function */
            /**
             * Unreserve service items
             * @async
             */
            clearReserved: function () {
                jQuery.post(master.data.serviceCalendar.endpoint, {
                    action: master.data.serviceCalendar.actions.delete
                }, function (data, textStatus, xhr) {
                    if (xhr.status > 199 && xhr.status < 300) {
                        location.href = location.href + '?editmode=true';
                    }
                });
            },
            /** @function */
            /**
             * Handler for reserved service items
             * @async
             */
            reserved: function () {
                var that = this;
                if (jQuery('.js-service-booking-orderlines').data('reserved') === 'True') {
                    jQuery('.js-servicebooking-reserved').show().on('click', '.js-servicebooking-reserved-unlock', function () {
                        var xmlHttp = new XMLHttpRequest();
                        xmlHttp.open("GET", "services/ServiceCalendar.ashx?action=deletetempapp", false); // false for synchronous request
                        xmlHttp.send(null);

                        that.clearReserved();
                    });
                }
            },
            /** @function */
            /**
             * Hack to disabled going back to checkout without services in cart
             */
            checkForServiceDate: function () {
                var jBookingOrderlines = jQuery('.js-service-booking-orderlines');
                if (jBookingOrderlines.find('.js-service-booking-orderline').length && jBookingOrderlines.data('reserved') === 'False') {
                    history.replaceState(null, null, location.pathname + '?editmode=true');
                }

                if (!jBookingOrderlines.find('.js-service-booking-orderline').length && jBookingOrderlines.data('reserved') === 'False') {
                    history.replaceState(null, null, location.href);
                }

                if (jBookingOrderlines.find('.js-service-booking-orderline').length && jBookingOrderlines.data('reserved') === 'False') {
                    history.pushState(null, null, location.href);
                }
                jQuery(window).on('popstate', function () {
                    if (jBookingOrderlines.find('.js-service-booking-orderline').length && jBookingOrderlines.data('reserved') === 'False') {
                        history.pushState(null, null, location.pathname + '?editmode=true');
                    }
                });
            },
            init: function () {
                this.reserved();
                this.checkForServiceDate();
                if (master.serviceBooking.selectors.form.length) {
                    this.load();
                }
            }
        },
        clearWorkShopAndSetNew: function(workshopID){
            return jQuery.when.apply(jQuery, [
                jQuery.post( master.data.workshops.endpoint, {
                    action: master.data.workshops.actions.clear
                }),
                jQuery.get( location.pathname + '?workshop=' + workshopID)
            ]);  
        },
        testForMismatchedWorkshopId: function(fnCallback){
            var cookieWorkshop = jQuery.cookie('FTZSelectedWorkshopCookie');
            if(cookieWorkshop !== null){
                var cookieWorkshopId = cookieWorkshop.split('=')[1],
                    currentPageWorkshopId = jQuery('.js-workshop-user-id').val();
                if(cookieWorkshopId.toString().toLowerCase() !== currentPageWorkshopId.toString().toLowerCase()){
                    //console.log('set id ' + currentPageWorkshopId + ' cookie was ' + cookieWorkshopId);
                    master.serviceBooking.clearWorkShopAndSetNew(currentPageWorkshopId).then(function (){
                        if(typeof fnCallback === 'function'){
                            fnCallback();
                        }
                    });
                } else {
                    if(typeof fnCallback === 'function'){
                        fnCallback();
                    }
                }

            } else{
                if(typeof fnCallback === 'function'){
                    fnCallback();
                }
            }
        },
        initBooking: function () {
            master.serviceBooking.utils.updateTabIndex();
            master.serviceBooking.tasks.init();
            master.serviceBooking.calendar.init();
            master.serviceBooking.timeslot.init();
            master.serviceBooking.calculator.init();
            master.serviceBooking.cart.init();
            master.serviceBooking.edit.init();
            master.serviceBooking.pickupDropoff.init();
            master.utils.autoSessionExtender(600000);

        },
        initCart: function () {
            var hasBOMItems = jQuery('.js-webshop-cart-bomitems').length > 0 ? true : false;
            if (hasBOMItems) {
                jQuery('.js-webshop-cart-bomitems').first().find('.js-webshop-cart-bomitem').each(function () {
                    master.serviceBooking.globals.timeslots.total = master.serviceBooking.globals.timeslots.total + (parseInt(jQuery(this).find('.js-webshop-cart-bomitem-timeslots').val()) * master.settings.booking.timeslotModifier);
                });
            }
            master.serviceBooking.api.booking('getmonth', master.serviceBooking.globals.today, master.serviceBooking.calendar.getMonth);
            master.serviceBooking.tasks.init();
            master.serviceBooking.calendar.init();
            master.serviceBooking.timeslot.init();
        },
        init: function () {
            if (jQuery('.js-service-bookservice-form').length) {
                this.getScript(master.serviceBooking.initBooking);
            }
            if (jQuery('.js-master-service-cart-view').length) {
                this.getScript(master.serviceBooking.initCart);
            }
            

        }
    };
}());
